module.exports = __webpack_public_path__ + "media/info_animation.d686d950.mp4";